// counts.js — the one NEW predicate and the masthead's count strip numbers.
// Pure; Watch.js recomputes with useMemo from the items in memory, so the
// strip refreshes on every fetchData (and therefore on CHECK NOW).

// NEW rail membership — strict === false: an absent triaged key means
// dispositioned (legacy rows) and must never qualify.
export function isNewItem(item) {
  return item?.status === 'Open' && item?.triaged === false;
}

export const COURTS = ['Mine', 'Theirs', 'Holding'];

/**
 * Over Open items only:
 *   total    every Open item
 *   new      isNewItem
 *   mine / theirs / holding   not new, by Court
 *   unset    not new, Court blank or anything else — exposed, never hidden
 */
export function countBoard(items) {
  const c = { total: 0, new: 0, mine: 0, theirs: 0, holding: 0, unset: 0 };
  for (const item of items || []) {
    if (item?.status !== 'Open') continue;
    c.total++;
    if (isNewItem(item)) { c.new++; continue; }
    const court = item.court;
    if (court === 'Mine') c.mine++;
    else if (court === 'Theirs') c.theirs++;
    else if (court === 'Holding') c.holding++;
    else c.unset++;
  }
  return c;
}
